import React, {  useEffect, useState } from 'react';
import VendorSideMenuBar from './VendorLayouts/VendorSideMenuBar';
import VendorTopMenuBar from './VendorLayouts/VendorTopMenuBar';
import '../../VendorStyles/VendorDashboard.css';
import NewOrders from './NewOrders';
import Preparing from './Preparing';
import Delivered from './Delivered';
import Declined from './Declined';
import PushToPickUp from './PushToPickUp';
import InTransit from './InTransit';
import {useLocation} from 'react-router-dom';
import { Badge } from '@mui/material';
import  { OrderContextuseOrders} from '../../ordersCount';

function VendorDashboard() {
    const {newOrdersCount,preparingCount,pushToPickUpCount,deliveredCount,declinedCount,inTransitCount} = OrderContextuseOrders();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(0);

    useEffect(()=>{
        const queryParams = new URLSearchParams(location.search);
        const tab = queryParams.get('tab');
        if(tab){
            setActiveTab(parseInt(tab));
        }
    },[location]);

    const tabContents = [
        <NewOrders key="new-orders" />,
        <Preparing key="preparing" />,
        <PushToPickUp key="push-to-pickup"/>,
        <InTransit  key="In-Transit"/>,
        <Delivered key="delivered" />,
        <Declined key="declined" />,
    ];

    return (
        <div>
            <VendorSideMenuBar />
            <VendorTopMenuBar />
            <div className="dashboard-container">
                <div className="vendor-common-container">
                    <div className="dashboard-left">
                        <div className="tabs-container-width">
                            <div className="tabs-container">
                                <button style={{ borderRadius: '5px 0px 0px 5px' }} className={`tab-button ${activeTab === 0 ? 'active' : ''}`} onClick={() => setActiveTab(0)}><h5 className='tabs-text'>New Orders</h5><Badge badgeContent={newOrdersCount} color="secondary"></Badge></button>
                                <button className={`tab-button ${activeTab === 1 ? 'active' : ''}`} onClick={() => setActiveTab(1)}><h5 className='tabs-text'>Preparing</h5><Badge badgeContent={preparingCount} color="secondary"></Badge></button>
                                <button className={`tab-button ${activeTab === 2 ? 'active' : ''}`} onClick={() => setActiveTab(2)}><h5 className='tabs-text'>Ready For Pickup</h5><Badge badgeContent={pushToPickUpCount} color="secondary"></Badge></button>
                                <button className={`tab-button ${activeTab === 3 ? 'active' : ''}`} onClick={() => setActiveTab(3)}><h5 className='tabs-text'>In-Transit</h5><Badge badgeContent={inTransitCount} color="secondary"></Badge></button>
                                <button className={`tab-button ${activeTab === 4 ? 'active' : ''}`} onClick={() => setActiveTab(4)}><h5 className='tabs-text'>Delivered</h5><Badge badgeContent={deliveredCount} color="secondary"></Badge></button>
                                <button className={`tab-button ${activeTab === 5 ? 'active' : ''}`} onClick={() => setActiveTab(5)}><h5 className='tabs-text'>Declined</h5><Badge badgeContent={declinedCount} color="secondary"></Badge></button>
                            </div>
                        </div>
                        <div className="content">
                            {tabContents[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorDashboard;
